'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * it-subtotal-cell
 */
ngModule.directive('itSubtotalCell', function () {
  return {
    restrict: "A",
    require: "^infiniTable",
    scope: false,
    link: function link($scope, $el, $attrs, tableCtrl) {
      var column = $scope.column;
      if (column.subtotal) {
        var setSubtotalValue = function setSubtotalValue(subtotalValues) {
          $scope.subtotalValue = subtotalValues ? subtotalValues[$scope.model.id][column.id] : undefined;
        };

        // initial set before watch to be on time for initial column width computation
        setSubtotalValue(tableCtrl.getContext().subtotalValues);
        $scope.$watch(function () {
          return tableCtrl.getContext().subtotalValues;
        }, setSubtotalValue);
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/infiniTable/standard/itSubtotalCell.js
// module id = 2815
// module chunks = 13